﻿"use strict";
if (typeof (Ahb) === 'undefined') {
    Ahb = {};
}

Ahb.MapUtilities = (function () {

    var mapModelGetterFunction;
    var callbackHandlerGetterFunction;

    function registerMapModelGetterFunction(func) {
        mapModelGetterFunction = func;
    }

    function getMapModel() {
        if (!mapModelGetterFunction) {
            throw new Error("Map model getter function is not defined.");
        }

        return mapModelGetterFunction();
    }

    function registerCallbackHandlerGetterFunction(func) {
        callbackHandlerGetterFunction = func;
    }
    
    function getCallbackHandler() {
        if (!callbackHandlerGetterFunction) {
            throw new Error("Callback handler getter function is not defined.");
        }

        return callbackHandlerGetterFunction();
    }

    return {
        registerMapModelGetterFunction: registerMapModelGetterFunction,
        getMapModel: getMapModel,
        registerCallbackHandlerGetterFunction: registerCallbackHandlerGetterFunction,
        getCallbackHandler: getCallbackHandler
    };

})();


//////////////////
// WEBPACK FOOTER
// ./Scripts/MapUtilities.js
// module id = 546
// module chunks = 0